module.exports = __webpack_public_path__ + "static/media/penetration-testing.48882cb7.png";